import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { updateProcessingStageStep, updateJobServiceTransition } from "requesters/jobServiceRequester";
import { getBaseUrl, getCurrentRole } from "../../../../../reducers";
import CommentBox from "../CommentBox";
import ConfirmationModal from "../../../modals/ConfirmationModal";
import CheckingStep from "./CheckingStep";
import FlagJobServiceModal from "../../../modals/FlagJobServiceModal";
import { ADMIN } from "../../../../../../../utils/constants";

const Processing3D = ({
  jobService, reloadData, comment, setComment
}) => {
  const {
    attributes: {
      completedStepsForProcessing3DOptions,
      jobNo,
      projectXJobNo,
      forProjectX,
      jobTitle
    }, id
  } = jobService
  const baseUrl = useSelector(getBaseUrl);
  const currentRole = useSelector(getCurrentRole)
  const isAdmin = currentRole.includes(ADMIN)
  const [checkingSteps, setCheckingSteps] = useState(completedStepsForProcessing3DOptions)
  const [requesting, setRequesting] = useState(false)
  const [targetStep, setTargetStep] = useState(null)
  const [showTransitionConfirmation, setShowTransitionConfirmation] = useState(false)
  const [showAddFlagModal, setShowAddFlagModal] = useState(false)

  const onClickStep = useCallback(step => {
    setRequesting(true)
    setTargetStep(step)
    const oldCheckingSteps = checkingSteps
    // eslint-disable-next-line
    const newCheckingSteps = checkingSteps.map(s => s.value === step.value ? { ...s, checked: !s.checked } : s)
    setCheckingSteps(newCheckingSteps)
    updateProcessingStageStep(baseUrl, id, step.value, !step.checked)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        setRequesting(false)
        setTargetStep(null)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => {
      console.log(err.response.data?.errors)
      setCheckingSteps(oldCheckingSteps)
      setTargetStep(null)
      setRequesting(false)
    })
  }, [baseUrl, id, reloadData])

  const sendToDrafting = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, "move-to-drafting-manager", comment)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        setRequesting(false)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  useEffect(() => {
    setCheckingSteps(completedStepsForProcessing3DOptions)
  }, [completedStepsForProcessing3DOptions])

  const generateCheckingSteps = useMemo(() => (
    checkingSteps.map((step, idx) => (
      <CheckingStep
        key={step.value}
        step={step}
        idx={idx}
        onClickStep={onClickStep}
        requesting={requesting}
        targetStep={targetStep} />
    ))
  ), [checkingSteps, requesting, targetStep])

  const AddFlagSection = () => {
    return (
      <div className="text-right">
        <button className="btn" type="button" onClick={() => setShowAddFlagModal(true)}>
          <i className="bi bi-flag-fill mr-2"></i>
          Add Flag
        </button>
        <FlagJobServiceModal
          show={showAddFlagModal}
          onHide={() => setShowAddFlagModal(false)}
          jobService={jobService}
          reloadData={reloadData} />
      </div>
    )
  }

  const allStepsCompleted = checkingSteps.every(step => step.checked)
  const displayJobNo = forProjectX ? projectXJobNo : jobNo

  return (
    <div className="processing-3d-section">
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="row justify-content-end align-baseline px-4">
            {AddFlagSection()}
          </div>
          <div className=" p-4">
            {generateCheckingSteps}
          </div>
        </div>
      </div>
      <div className="transition-comment">
        <CommentBox comment={comment} setComment={setComment} />
        <div className="row mt-4">
          <div className="mr-4 pt-2">Send to</div>
          <div className="mr-2">
            <button
              className={`btn ${(allStepsCompleted || isAdmin) ? "btn-outline-primary" : "btn-outline-secondary"}`}
              type="button"
              disabled={(!isAdmin && !allStepsCompleted) || requesting}
              onClick={() => setShowTransitionConfirmation(true)}>
              Drafting Required
            </button>
            <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={showTransitionConfirmation} resetState={() => setShowTransitionConfirmation(false)} sendTo={sendToDrafting} messageType="Drafting"></ConfirmationModal>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Processing3D;